package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

/**
 * Translations for the Manage NETPs page
 */
enum class ManageIntNetpsI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    FORM_TITLE(mapOf(PageLocale.PT to "Gerir Sujeitos Passivos")),

    NETP_ID_COLUMN(mapOf(PageLocale.PT to "Referência")),
    NETP_STATUS_COLUMN(mapOf(PageLocale.PT to "Situação")),
    NETP_UPDATE_TIMESTAMP_COLUMN(mapOf(PageLocale.PT to "Data atualização")),
    NETP_ACTIONS_COLUMN(mapOf(PageLocale.PT to "")),

    SELECT_VATID_NETP_LABEL(mapOf(PageLocale.PT to "Nº VAT/TIN:")),
    SELECT_IOSS_NETP_LABEL(mapOf(PageLocale.PT to "Nº IOSS:")),

    VAT_ID_ISSUER_LABEL(mapOf(PageLocale.PT to "País: ")),
    VAT_NUM_LABEL(mapOf(PageLocale.PT to "Num. IVA: ")),
    TAX_NUM_LABEL(mapOf(PageLocale.PT to "Num. Fiscal: ")),
    IOSS_NUM_LABEL(mapOf(PageLocale.PT to "Num. IOSS: ")),

    NEW_NETP_BUTTON(mapOf(PageLocale.PT to "adicionar")),
    NETP_DETAIL_BUTTON(mapOf(PageLocale.PT to "consultar")),
    NETP_REREGISTER_BUTTON(mapOf(PageLocale.PT to "re-registar")),
    NETP_EDIT_BUTTON(mapOf(PageLocale.PT to "editar")),
    NETP_REQ_EXCLUSION_BUTTON(mapOf(PageLocale.PT to "pedir exclusão")),
    ;
}
